import React from 'react';

import { LegacyIconProps } from './iconUtilities';

export function ZoomInIcon({ 
    width = 16, 
    height = 16, 
    color = '#666666'
}: LegacyIconProps) {
    return (
        <svg id='mapZoomInIcon' className='mapIcon' viewBox='0 0 16 16' width={width} height={height} fill={color}>
            <rect x='0' y='6.35362319' width='16' height='3.2' rx='1'></rect>
            <path d='M7.46555367,16 C6.87706463,16 6.4,15.6803939 6.4,15.270937 L6.4,0.729063034 C6.4,0.326412639 6.87217102,0 7.46555367,0 L8.53444633,0 C9.12293537,0 9.6,0.319606066 9.6,0.729063034 L9.6,15.270937 C9.6,15.6735874 9.12782898,16 8.53444633,16 L7.46555367,16 L7.46555367,16 Z'></path>
        </svg>
    );
}
